// This file ensures that Vite includes all image formats (PNG, WebP, AVIF) in the build
// by explicitly importing them, since the OptimizedImage component generates paths dynamically

// Hero Images - Updated to use new uploaded images
import HeroimgPng from './flowers/flowerHero.png';
import HeroimgWebp from './Heroimg.webp';
import HeroimgAvif from './Heroimg.avif';

import flowerHeroPng from './flowers/flowerHero.png';
import flowerHeroWebp from './flowers/flowerHero.webp';
import flowerHeroAvif from './flowers/flowerHero.avif';

import fruitHeroPng from './fruits/fruitsHero.png';
import fruitHeroWebp from './fruits/fruitsHero.webp';
import fruitHeroAvif from './fruits/fruitsHero.avif';

import fruitsHeroPng from './fruits/fruitsHero.png';
import fruitsHeroWebp from './fruits/fruitsHero.webp';
import fruitsHeroAvif from './fruits/fruitsHero.avif';

// Gift Images
import giftImgPng from './giftImg.png';
import giftImgWebp from './giftImg.webp';
import giftImgAvif from './giftImg.avif';

import bouquetGiftPng from './flowers/bouquetGift.png';
import bouquetGiftWebp from './flowers/bouquetGift.webp';
import bouquetGiftAvif from './flowers/bouquetGift.avif';

import couponGiftPng from './couponGift.png';
import couponGiftWebp from './couponGift.webp';
import couponGiftAvif from './couponGift.avif';

// Fruits Section
import fruitsSectionPng from './fruits/fruitsSection.png';
import fruitsSectionWebp from './fruits/fruitsSection.webp';
import fruitsSectionAvif from './fruits/fruitsSection.avif';

// Feature Icons
import farmWhyPng from './farmWhy.png';
import farmWhyWebp from './farmWhy.webp';
import farmWhyAvif from './farmWhy.avif';

import varietyWhyPng from './varietyWhy.png';
import varietyWhyWebp from './varietyWhy.webp';
import varietyWhyAvif from './varietyWhy.avif';

import freshWhyPng from './freshWhy.png';
import freshWhyWebp from './freshWhy.webp';
import freshWhyAvif from './freshWhy.avif';

import giftWhyPng from './giftWhy.png';
import giftWhyWebp from './giftWhy.webp';
import giftWhyAvif from './giftWhy.avif';

// How It Works Icons
import howIt01Png from './howIt01.png';
import howIt01Webp from './howIt01.webp';
import howIt01Avif from './howIt01.avif';

import howIt02Png from './howIt02.png';
import howIt02Webp from './howIt02.webp';
import howIt02Avif from './howIt02.avif';

import howIt03Png from './howIt03.png';
import howIt03Webp from './howIt03.webp';
import howIt03Avif from './howIt03.avif';

// Service Icons
import servicesFlowerPng from './flowers/servicesFlower.png';
import servicesFlowerWebp from './flowers/servicesFlower.webp';
import servicesFlowerAvif from './flowers/servicesFlower.avif';

import servicesFruitPng from './fruits/servicesFruit.png';
import servicesFruitWebp from './fruits/servicesFruit.webp';
import servicesFruitAvif from './fruits/servicesFruit.avif';

import servicesCatGrassPng from './catGrass/servicesCatGrass.png';
import servicesCatGrassWebp from './catGrass/servicesCatGrass.webp';
import servicesCatGrassAvif from './catGrass/servicesCatGrass.avif';

// Fruit Feature Images
import fruitFarmPng from './fruits/fruitFarm.png';
import fruitFarmWebp from './fruits/fruitFarm.webp';
import fruitFarmAvif from './fruits/fruitFarm.avif';

import fruitVarietyPng from './fruits/fruitVariety.png';
import fruitVarietyWebp from './fruits/fruitVariety.webp';
import fruitVarietyAvif from './fruits/fruitVariety.avif';

import fruitFreshPng from './fruits/fruitFresh.png';
import fruitFreshWebp from './fruits/fruitFresh.webp';
import fruitFreshAvif from './fruits/fruitFresh.avif';

import fruitGiftPng from './fruits/fruitGift.png';
import fruitGiftWebp from './fruits/fruitGift.webp';
import fruitGiftAvif from './fruits/fruitGift.avif';

// Smaller images (logos, plan images, etc.)
import flowerLogoPng from './flowers/flower_logo.png';
import flowerLogoWebp from './flowers/flower_logo.webp';
import flowerLogoAvif from './flowers/flower_logo.avif';

import fruitLogoPng from './fruits/fruit_logo.png';
import fruitLogoWebp from './fruits/fruit_logo.webp';
import fruitLogoAvif from './fruits/fruit_logo.avif';

import flowersLargePng from './flowers/flowers_large.png';
import flowersLargeWebp from './flowers/flowers_large.webp';
import flowersLargeAvif from './flowers/flowers_large.avif';

import flowersSmallPng from './flowers/flowers_small.png';
import flowersSmallWebp from './flowers/flowers_small.webp';
import flowersSmallAvif from './flowers/flowers_small.avif';

import fruitsPremiumPng from './fruits/Fruits-Premium.png';
import fruitsPremiumWebp from './fruits/Fruits-Premium.webp';
import fruitsPremiumAvif from './fruits/Fruits-Premium.avif';

import fruitsStandardPng from './fruits/Fruits-Standard.png';
import fruitsStandardWebp from './fruits/Fruits-Standard.webp';
import fruitsStandardAvif from './fruits/Fruits-Standard.avif';

import vasePng from './flowers/vase.png';
import vaseWebp from './flowers/vase.webp';
import vaseAvif from './flowers/vase.avif';

// Fruit Blacklist Images
import blacklistMangoPng from './fruits/blacklist/blacklist_Mango.png';
import blacklistMangoWebp from './fruits/blacklist/blacklist_Mango.webp';
import blacklistMangoAvif from './fruits/blacklist/blacklist_Mango.avif';

import blacklistPapayaPng from './fruits/blacklist/blacklist_Papaya.png';
import blacklistPapayaWebp from './fruits/blacklist/blacklist_Papaya.webp';
import blacklistPapayaAvif from './fruits/blacklist/blacklist_Papaya.avif';

import blacklistDragonfruitPng from './fruits/blacklist/blacklist_Dragonfruit.png';
import blacklistDragonfruitWebp from './fruits/blacklist/blacklist_Dragonfruit.webp';
import blacklistDragonfruitAvif from './fruits/blacklist/blacklist_Dragonfruit.avif';

import blacklistRambutanPng from './fruits/blacklist/blacklist_Rambutan.png';
import blacklistRambutanWebp from './fruits/blacklist/blacklist_Rambutan.webp';
import blacklistRambutanAvif from './fruits/blacklist/blacklist_Rambutan.avif';

import blacklistLycheePng from './fruits/blacklist/blacklist_Lychee.png';
import blacklistLycheeWebp from './fruits/blacklist/blacklist_Lychee.webp';
import blacklistLycheeAvif from './fruits/blacklist/blacklist_Lychee.avif';

import blacklistLonganPng from './fruits/blacklist/blacklist_Longan.png';
import blacklistLonganWebp from './fruits/blacklist/blacklist_Longan.webp';
import blacklistLonganAvif from './fruits/blacklist/blacklist_Longan.avif';

import blacklistDurianPng from './fruits/blacklist/blacklist_Durian.png';
import blacklistDurianWebp from './fruits/blacklist/blacklist_Durian.webp';
import blacklistDurianAvif from './fruits/blacklist/blacklist_Durian.avif';

import blacklistMangosteenPng from './fruits/blacklist/blacklist_Mangosteen.png';
import blacklistMangosteenWebp from './fruits/blacklist/blacklist_Mangosteen.webp';
import blacklistMangosteenAvif from './fruits/blacklist/blacklist_Mangosteen.avif';

import blacklistJackfruitPng from './fruits/blacklist/blacklist_Jackfruit.png';
import blacklistJackfruitWebp from './fruits/blacklist/blacklist_Jackfruit.webp';
import blacklistJackfruitAvif from './fruits/blacklist/blacklist_Jackfruit.avif';

import blacklistStarfruitPng from './fruits/blacklist/blacklist_Starfruit.png';
import blacklistStarfruitWebp from './fruits/blacklist/blacklist_Starfruit.webp';
import blacklistStarfruitAvif from './fruits/blacklist/blacklist_Starfruit.avif';

import blacklistGuavaPng from './fruits/blacklist/blacklist_Guava.png';
import blacklistGuavaWebp from './fruits/blacklist/blacklist_Guava.webp';
import blacklistGuavaAvif from './fruits/blacklist/blacklist_Guava.avif';

import blacklistPassionfruitPng from './fruits/blacklist/blacklist_Passionfruit.png';
import blacklistPassionfruitWebp from './fruits/blacklist/blacklist_Passionfruit.webp';
import blacklistPassionfruitAvif from './fruits/blacklist/blacklist_Passionfruit.avif';

import blacklistRoseapplePng from './fruits/blacklist/blacklist_Roseapple.png';
import blacklistRoseappleWebp from './fruits/blacklist/blacklist_Roseapple.webp';
import blacklistRoseappleAvif from './fruits/blacklist/blacklist_Roseapple.avif';

import blacklistTamarindPng from './fruits/blacklist/blacklist_Tamarind.png';
import blacklistTamarindWebp from './fruits/blacklist/blacklist_Tamarind.webp';
import blacklistTamarindAvif from './fruits/blacklist/blacklist_Tamarind.avif';

import blacklistSnakefruitPng from './fruits/blacklist/blacklist_Snakefruit.png';
import blacklistSnakefruitWebp from './fruits/blacklist/blacklist_Snakefruit.webp';
import blacklistSnakefruitAvif from './fruits/blacklist/blacklist_Snakefruit.avif';

import blacklistCoconutPng from './fruits/blacklist/blacklist_Coconut.png';
import blacklistCoconutWebp from './fruits/blacklist/blacklist_Coconut.webp';
import blacklistCoconutAvif from './fruits/blacklist/blacklist_Coconut.avif';

// Cat Grass Images
import catGrassHeroPng from './catGrass/catGrass_hero.png';
import catGrassHeroWebp from './catGrass/catGrass_hero.webp';
import catGrassHeroAvif from './catGrass/catGrass_hero.avif';
import catGrassSmallPng from './catGrass/catGrass_small.png';
import catGrassSmallWebp from './catGrass/catGrass_small.webp';
import catGrassSmallAvif from './catGrass/catGrass_small.avif';

// Export all images for use in components
export {
  // Hero Images
  HeroimgPng, HeroimgWebp, HeroimgAvif,
  flowerHeroPng, flowerHeroWebp, flowerHeroAvif,
  fruitHeroPng, fruitHeroWebp, fruitHeroAvif,
  fruitsHeroPng, fruitsHeroWebp, fruitsHeroAvif,
  
  // Gift Images
  giftImgPng, giftImgWebp, giftImgAvif,
  bouquetGiftPng, bouquetGiftWebp, bouquetGiftAvif,
  couponGiftPng, couponGiftWebp, couponGiftAvif,
  
  // Fruits Section
  fruitsSectionPng, fruitsSectionWebp, fruitsSectionAvif,
  
  // Feature Icons
  farmWhyPng, farmWhyWebp, farmWhyAvif,
  varietyWhyPng, varietyWhyWebp, varietyWhyAvif,
  freshWhyPng, freshWhyWebp, freshWhyAvif,
  giftWhyPng, giftWhyWebp, giftWhyAvif,
  
  // How It Works Icons
  howIt01Png, howIt01Webp, howIt01Avif,
  howIt02Png, howIt02Webp, howIt02Avif,
  howIt03Png, howIt03Webp, howIt03Avif,
  
  // Service Icons
  servicesFlowerPng, servicesFlowerWebp, servicesFlowerAvif,
  servicesFruitPng, servicesFruitWebp, servicesFruitAvif,
  servicesCatGrassPng, servicesCatGrassWebp, servicesCatGrassAvif,
  
  // Fruit Feature Images
  fruitFarmPng, fruitFarmWebp, fruitFarmAvif,
  fruitVarietyPng, fruitVarietyWebp, fruitVarietyAvif,
  fruitFreshPng, fruitFreshWebp, fruitFreshAvif,
  fruitGiftPng, fruitGiftWebp, fruitGiftAvif,
  
  // Smaller images
  flowerLogoPng, flowerLogoWebp, flowerLogoAvif,
  fruitLogoPng, fruitLogoWebp, fruitLogoAvif,
  flowersLargePng, flowersLargeWebp, flowersLargeAvif,
  flowersSmallPng, flowersSmallWebp, flowersSmallAvif,
  fruitsPremiumPng, fruitsPremiumWebp, fruitsPremiumAvif,
  fruitsStandardPng, fruitsStandardWebp, fruitsStandardAvif,
  vasePng, vaseWebp, vaseAvif,
  
  // Fruit Blacklist Images
  blacklistMangoPng, blacklistMangoWebp, blacklistMangoAvif,
  blacklistPapayaPng, blacklistPapayaWebp, blacklistPapayaAvif,
  blacklistDragonfruitPng, blacklistDragonfruitWebp, blacklistDragonfruitAvif,
  blacklistRambutanPng, blacklistRambutanWebp, blacklistRambutanAvif,
  blacklistLycheePng, blacklistLycheeWebp, blacklistLycheeAvif,
  blacklistLonganPng, blacklistLonganWebp, blacklistLonganAvif,
  blacklistDurianPng, blacklistDurianWebp, blacklistDurianAvif,
  blacklistMangosteenPng, blacklistMangosteenWebp, blacklistMangosteenAvif,
  blacklistJackfruitPng, blacklistJackfruitWebp, blacklistJackfruitAvif,
  blacklistStarfruitPng, blacklistStarfruitWebp, blacklistStarfruitAvif,
  blacklistGuavaPng, blacklistGuavaWebp, blacklistGuavaAvif,
  blacklistPassionfruitPng, blacklistPassionfruitWebp, blacklistPassionfruitAvif,
  blacklistRoseapplePng, blacklistRoseappleWebp, blacklistRoseappleAvif,
  blacklistTamarindPng, blacklistTamarindWebp, blacklistTamarindAvif,
  blacklistSnakefruitPng, blacklistSnakefruitWebp, blacklistSnakefruitAvif,
  blacklistCoconutPng, blacklistCoconutWebp, blacklistCoconutAvif,
  catGrassHeroPng, catGrassHeroWebp, catGrassHeroAvif,
  catGrassSmallPng, catGrassSmallWebp, catGrassSmallAvif
};

// Image assets object with all formats
export const imageAssets = {
  // Hero Images
  Heroimg: { png: HeroimgPng, webp: HeroimgWebp, avif: HeroimgAvif },
  flowerHero: { png: flowerHeroPng, webp: flowerHeroWebp, avif: flowerHeroAvif },
  fruitHero: { png: fruitHeroPng, webp: fruitHeroWebp, avif: fruitHeroAvif },
  fruitsHero: { png: fruitsHeroPng, webp: fruitsHeroWebp, avif: fruitsHeroAvif },
  
  // Gift Images
  giftImg: { png: giftImgPng, webp: giftImgWebp, avif: giftImgAvif },
  bouquetGift: { png: bouquetGiftPng, webp: bouquetGiftWebp, avif: bouquetGiftAvif },
  couponGift: { png: couponGiftPng, webp: couponGiftWebp, avif: couponGiftAvif },
  
  // Fruits Section
  fruitsSection: { png: fruitsSectionPng, webp: fruitsSectionWebp, avif: fruitsSectionAvif },
  
  // Feature Icons
  farmWhy: { png: farmWhyPng, webp: farmWhyWebp, avif: farmWhyAvif },
  varietyWhy: { png: varietyWhyPng, webp: varietyWhyWebp, avif: varietyWhyAvif },
  freshWhy: { png: freshWhyPng, webp: freshWhyWebp, avif: freshWhyAvif },
  giftWhy: { png: giftWhyPng, webp: giftWhyWebp, avif: giftWhyAvif },
  
  // How It Works Icons
  howIt01: { png: howIt01Png, webp: howIt01Webp, avif: howIt01Avif },
  howIt02: { png: howIt02Png, webp: howIt02Webp, avif: howIt02Avif },
  howIt03: { png: howIt03Png, webp: howIt03Webp, avif: howIt03Avif },
  
  // Service Icons
  servicesFlower: { png: servicesFlowerPng, webp: servicesFlowerWebp, avif: servicesFlowerAvif },
  servicesFruit: { png: servicesFruitPng, webp: servicesFruitWebp, avif: servicesFruitAvif },
  servicesCatGrass: { png: servicesCatGrassPng, webp: servicesCatGrassWebp, avif: servicesCatGrassAvif },
  
  // Fruit Feature Images
  fruitFarm: { png: fruitFarmPng, webp: fruitFarmWebp, avif: fruitFarmAvif },
  fruitVariety: { png: fruitVarietyPng, webp: fruitVarietyWebp, avif: fruitVarietyAvif },
  fruitFresh: { png: fruitFreshPng, webp: fruitFreshWebp, avif: fruitFreshAvif },
  fruitGift: { png: fruitGiftPng, webp: fruitGiftWebp, avif: fruitGiftAvif },
  
  // Smaller images
  flowerLogo: { png: flowerLogoPng, webp: flowerLogoWebp, avif: flowerLogoAvif },
  fruitLogo: { png: fruitLogoPng, webp: fruitLogoWebp, avif: fruitLogoAvif },
  flowersLarge: { png: flowersLargePng, webp: flowersLargeWebp, avif: flowersLargeAvif },
  flowersSmall: { png: flowersSmallPng, webp: flowersSmallWebp, avif: flowersSmallAvif },
  fruitsPremium: { png: fruitsPremiumPng, webp: fruitsPremiumWebp, avif: fruitsPremiumAvif },
  fruitsStandard: { png: fruitsStandardPng, webp: fruitsStandardWebp, avif: fruitsStandardAvif },
  vase: { png: vasePng, webp: vaseWebp, avif: vaseAvif },
  
  // Fruit Blacklist Images
  blacklistMango: { png: blacklistMangoPng, webp: blacklistMangoWebp, avif: blacklistMangoAvif },
  blacklistPapaya: { png: blacklistPapayaPng, webp: blacklistPapayaWebp, avif: blacklistPapayaAvif },
  blacklistDragonfruit: { png: blacklistDragonfruitPng, webp: blacklistDragonfruitWebp, avif: blacklistDragonfruitAvif },
  blacklistRambutan: { png: blacklistRambutanPng, webp: blacklistRambutanWebp, avif: blacklistRambutanAvif },
  blacklistLychee: { png: blacklistLycheePng, webp: blacklistLycheeWebp, avif: blacklistLycheeAvif },
  blacklistLongan: { png: blacklistLonganPng, webp: blacklistLonganWebp, avif: blacklistLonganAvif },
  blacklistDurian: { png: blacklistDurianPng, webp: blacklistDurianWebp, avif: blacklistDurianAvif },
  blacklistMangosteen: { png: blacklistMangosteenPng, webp: blacklistMangosteenWebp, avif: blacklistMangosteenAvif },
  blacklistJackfruit: { png: blacklistJackfruitPng, webp: blacklistJackfruitWebp, avif: blacklistJackfruitAvif },
  blacklistStarfruit: { png: blacklistStarfruitPng, webp: blacklistStarfruitWebp, avif: blacklistStarfruitAvif },
  blacklistGuava: { png: blacklistGuavaPng, webp: blacklistGuavaWebp, avif: blacklistGuavaAvif },
  blacklistPassionfruit: { png: blacklistPassionfruitPng, webp: blacklistPassionfruitWebp, avif: blacklistPassionfruitAvif },
  blacklistRoseapple: { png: blacklistRoseapplePng, webp: blacklistRoseappleWebp, avif: blacklistRoseappleAvif },
  blacklistTamarind: { png: blacklistTamarindPng, webp: blacklistTamarindWebp, avif: blacklistTamarindAvif },
  blacklistSnakefruit: { png: blacklistSnakefruitPng, webp: blacklistSnakefruitWebp, avif: blacklistSnakefruitAvif },
  blacklistCoconut: { png: blacklistCoconutPng, webp: blacklistCoconutWebp, avif: blacklistCoconutAvif },
  catGrass_hero: { png: catGrassHeroPng, webp: catGrassHeroWebp, avif: catGrassHeroAvif },
  catGrassSmall: { png: catGrassSmallPng, webp: catGrassSmallWebp, avif: catGrassSmallAvif }
};

// Helper function to get image paths by name
export function getImageAsset(name: keyof typeof imageAssets) {
  return imageAssets[name];
}

// Type for image asset
export type ImageAssetType = {
  png: string;
  webp: string;
  avif: string;
};

// Default export for backward compatibility
export default imageAssets; 